import { SplitContainer } from '@if/mui'
import LoanCalendarStatusCards from './Card/LoanCalendarStatusCards'
import LoanCalendarActionProvider from './LoanCalendarActionProvider'
import LoanCalendarTable from './LoanCalendarTable/LoanCalendarTable'

/** The calendar tab. Its pending actions live in the page's LoanCalendarSimulationProvider, above the tabs. */
const LoanCalendarContent = () => (
  <LoanCalendarActionProvider>
    <SplitContainer
      asidePosition="left"
      asideStack="above"
      asideCollapseKey="loan-calendar"
      aside={<LoanCalendarStatusCards />}
      main={<LoanCalendarTable />}
    />
  </LoanCalendarActionProvider>
)

export default LoanCalendarContent
